<template>
  <div class="row align-items-baseline">
    <div class="col">
      <FormLabel label-is-fake>Costi del personale</FormLabel>
    </div>
    <div class="col-auto">
      <button class="btn btn-secondary" type="button" @click.prevent="addCost">Aggiungi costo del personale</button>
    </div>
    <AwlTable class="col-12" :heading="headings" :rows="value">
      <template #column-key-costId="{ value, rowNumber }">
        <FormInputSelect
          :value="value"
          :options="selectPersonnelCosts"
          optionLabel="label"
          optionValue="id"
          @input="updateLibraryCostInCost(rowNumber, $event)"
        />
      </template>

      <template #column-key-quantity="{ row, value, rowNumber }">
        <template v-if="!row.cost">-</template>
        <template v-else>
          <div class="input-group">
            <FormInputText type="number" :min="1" :step="1" :value="value" @input="updateQuantityInCost(rowNumber, $event)" />
            <div class="input-group-append">
              <div class="input-group-text">Ore</div>
            </div>
          </div>
        </template>
      </template>

      <template #actions-content="{ rowNumber }">
        <ActionDelete @click="removeCost(rowNumber)" />
      </template>
    </AwlTable>
  </div>
</template>

<script>

import formatMoney from '@/filters/formatMoney';

export default {
  name: 'form-input-project-library-costs-widget',
  components: {
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    FormInputSelect: () => import('@/libs/Form/components/Inputs/FormInputSelect'),
  },
  filters: {
    money: formatMoney,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    costs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectPersonnelCosts () {
      return (this.costs || []).map(c => {
        c.label = c.name;

        return c;
      });
    },
    headings () {
      return [
        { key: 'costId', label: 'Costo del personale' },
        { key: 'quantity', label: 'Ore' },
      ];
    },
  },
  methods: {
    addCost () {
      const newValue = [...this.value];
      newValue.push({
        cost: null,
        costId: null,
        quantity: 1,
      });

      this.$emit('input', newValue);
    },
    removeCost (rowNumber) {
      this.$emit('input', (this.value || []).filter((r, i) => i !== rowNumber));
    },
    findCost (costId) {
      return this.costs.find(c => c.id === costId);
    },
    updateQuantityInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.quantity = parseInt(value) || 0;
        }

        return r;
      }));
    },
    updateLibraryCostInCost (rowNumber, value) {
      this.$emit('input', (this.value || []).map((r, i) => {
        if (i === rowNumber) {
          const cost = this.findCost(value);

          if (cost) {
            r.costId = value || null;
            r.cost = cost;
          }
        }

        return r;
      }));
    },
  },
};

</script>
